import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreConfigContext } from '/src/providers';
import {
    Carousel,
    H2,
    Recipe,
} from '/src/components';
import * as styles from './styles.scss';

const RecipesCarousel = ({ data, isLoading }) => {
    const { translate } = useStoreConfigContext();

    return (
        <>
            {
                (!!data?.length || isLoading) &&
                <H2 className={styles.title}>
                    {translate('Recipes and blog posts')}
                </H2>
            }
            {
                !!data?.length && !isLoading &&
                <>
                    <Carousel
                        showSlides={3}
                        isAbsoluteArrows={false}
                        className={styles.desktop}
                    >
                        {
                            data.map(recipe => (
                                <div
                                    key={recipe.recipe_id}
                                    className={styles.wrapper}
                                >
                                    <Recipe recipe={recipe} />
                                </div>
                            ))
                        }
                    </Carousel>
                    <Carousel
                        showSlides={2}
                        isAbsoluteArrows={false}
                        className={styles.plane}
                    >
                        {
                            data.map(recipe => (
                                <div
                                    key={recipe.recipe_id}
                                    className={styles.wrapper}
                                >
                                    <Recipe recipe={recipe} />
                                </div>
                            ))
                        }
                    </Carousel>
                    <Carousel
                        showSlides={1}
                        isAbsoluteArrows={true}
                        className={styles.mobile}
                    >
                        {
                            data.map(recipe => (
                                <div
                                    key={recipe.recipe_id}
                                    className={styles.wrapper}
                                >
                                    <Recipe recipe={recipe} />
                                </div>
                            ))
                        }
                    </Carousel>
                </>
            }
            {
                isLoading &&
                <Carousel showSlides={1} isShowArrows={false}>
                    {
                        [...Array(1).keys()].map(key => (
                            <div
                                key={key}
                                className={styles.wrapper}
                            >
                                <Recipe />
                            </div>
                        ))
                    }
                </Carousel>
            }
            {
                (!!data?.length || isLoading) &&
                <Link
                    className={styles.recipes}
                    to="/recipes"
                >
                    {translate('Show all recipes')}
                </Link>
            }
        </>
    );
};

export default RecipesCarousel;
